<template>
	<div class="pt-2">
		<app-table
			class="is-not-selectable"
			:current-page="currentPage"
			:last-page="lastPage"
			name="modules-card-list"
			:columns="columns"
			:rows="rows"
			@on-page="$emit('on-page', $event)"
			@on-search-event="$emit('on-search', $event)"
		>
			<template slot="rows" slot-scope="props">
				<td v-show="showRow(columns, 1)" class="is-not-selectable">
					{{ props.row.code }}
				</td>
				<td v-show="showRow(columns, 2)">{{ props.row.name }}</td>
				<td v-show="showRow(columns, 3)">{{ props.row.description }}</td>
				<td v-show="showRow(columns, 4)">{{ props.row.example }}</td>
			</template>
		</app-table>
	</div>
</template>

<script>
export default {
	name: 'modules-list-ats',
	props: {
		columns: {
			type: Array,
			required: true,
		},
		currentPage: {
			type: Number,
			default: 1,
		},
		lastPage: {
			type: Number,
			default: 0,
		},
		rows: {
			type: Array,
			required: true,
		},
	},
};
</script>



// WEBPACK FOOTER //
// src/components/definitions-ats/modules-list-ats.vue